import { WHY_US } from "../mock";
import { getIcon } from "../lib/icons";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function WhyUs() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
              Why Investment Hub
            </div>
            <h2 className="mt-4 text-[36px] lg:text-[52px] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#0d1a2e]">
              A hub built for the way Britain{" "}
              <span className="text-[#16d196]">actually invests today.</span>
            </h2>
            <p className="mt-5 text-[#0d1a2e]/65 text-[16.5px] leading-relaxed">
              Most platforms haven't been updated in a decade. We rebuilt the whole
              process — mobile-first, transparent, FCA-aware and powered by a curated
              panel of specialist UK issuers.
            </p>
            <Link to="/about" className="mt-7 inline-flex items-center gap-1.5 text-[14.5px] font-bold text-[#0d1a2e] hover:text-[#16d196]">
              More about us
              <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
            </Link>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {WHY_US.map((w) => {
              const Icon = getIcon(w.icon);
              return (
                <div
                  key={w.title}
                  className="bg-[#f7faf9] border border-[#0d1a2e]/8 rounded-2xl p-6"
                >
                  <div className="w-11 h-11 rounded-xl bg-[#e3f7ee] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#0d1a2e]" strokeWidth={2.2} />
                  </div>
                  <h3 className="mt-4 text-[17px] font-extrabold text-[#0d1a2e] tracking-tight">
                    {w.title}
                  </h3>
                  <p className="mt-1.5 text-[13.5px] text-[#0d1a2e]/60 leading-relaxed">
                    {w.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
